"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchSuggestion = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
const suggestion_button_1 = require("@/components/domains/shared/suggestion-button");
const utils_1 = require("@/utils");
/**
 * 검색 추천 키워드 버튼. mm-button(size=small)을 베이스로 합니다.
 * 클릭 시 search-suggestion-select 이벤트를 발행합니다.
 */
let SearchSuggestion = class SearchSuggestion extends lit_1.LitElement {
    constructor() {
        super(...arguments);
        this.value = '';
        this.handleClick = () => {
            (0, utils_1.emit)(this, 'search-suggestion-select', { value: (0, suggestion_button_1.resolveSuggestionValue)(this) });
        };
    }
    render() {
        return (0, suggestion_button_1.renderSuggestionButton)(this.icon, this.handleClick);
    }
};
SearchSuggestion.styles = [suggestion_button_1.suggestionButtonStyles];
__decorate([
    (0, decorators_js_1.property)({ type: String })
], SearchSuggestion.prototype, "value", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String })
], SearchSuggestion.prototype, "icon", void 0);
SearchSuggestion = __decorate([
    (0, decorators_js_1.customElement)('mm-search-suggestion')
], SearchSuggestion);
exports.SearchSuggestion = SearchSuggestion;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic2VhcmNoLXN1Z2dlc3Rpb24uanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJzZWFyY2gtc3VnZ2VzdGlvbi50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7QUFBQSw2QkFBZ0M7QUFDaEMscURBQTJEO0FBSTNELHFGQUlzRDtBQUN0RCxtQ0FBOEI7QUFFOUI7OztHQUdHO0FBRUksSUFBTSxnQkFBZ0IsR0FBdEIsTUFBTSxnQkFBaUIsU0FBUSxnQkFBVTtJQUF6Qzs7UUFFdUIsVUFBSyxHQUFHLEVBQUUsQ0FBQTtRQU85QixnQkFBVyxHQUFHLEdBQUcsRUFBRTtZQUN6QixJQUFBLFlBQUksRUFBQyxJQUFJLEVBQUUsMEJBQTBCLEVBQUUsRUFBRSxLQUFLLEVBQUUsSUFBQSwwQ0FBc0IsRUFBQyxJQUFJLENBQUMsRUFBRSxDQUFDLENBQUE7UUFDakYsQ0FBQyxDQUFBO0lBQ0gsQ0FBQztJQVBDLE1BQU07UUFDSixPQUFPLElBQUEsMENBQXNCLEVBQUMsSUFBSSxDQUFDLElBQUksRUFBRSxJQUFJLENBQUMsV0FBVyxDQUFDLENBQUE7SUFDNUQsQ0FBQzs7QUFOTSx1QkFBTSxHQUFHLENBQUMsMENBQXNCLENBQUMsQ0FBQTtBQUNaO0lBQTNCLElBQUEsd0JBQVEsRUFBQyxFQUFFLElBQUksRUFBRSxNQUFNLEVBQUUsQ0FBQzsrQ0FBVztBQUNWO0lBQTNCLElBQUEsd0JBQVEsRUFBQyxFQUFFLElBQUksRUFBRSxNQUFNLEVBQUUsQ0FBQzs4Q0FBZ0I7QUFIaEMsZ0JBQWdCO0lBRDVCLElBQUEsNkJBQWEsRUFBQyxzQkFBc0IsQ0FBQztHQUN6QixnQkFBZ0IsQ0FZNUI7QUFaWSw0Q0FBZ0IifQ==